import { mapError } from "@/utils/ObservableUtils";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { from, Observable } from "rxjs";

class Service {

  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({ baseURL: `${process.env.VUE_APP_DISCOVERY_UI_MINOS_URL}` });
  }

  public get(path: string, config?: AxiosRequestConfig): Observable<AxiosResponse> {
    const request = this.client.get(path, config);
    return from(request).pipe(mapError());
  }

  public post(path: string, data: object, config?: AxiosRequestConfig): Observable<AxiosResponse> {
    const options = {
      headers: {"Content-Type": "text/json"}
    };
    const request = this.client.post(path, data, {...options, ...config});
    return from(request).pipe(mapError());
  }

  public put(path: string, data?: object): Observable<AxiosResponse> {
    const request = this.client.put(path, data);
    return from(request).pipe(mapError());
  }

  public patch(path: string, data?: object): Observable<AxiosResponse> {
    const request = this.client.patch(path, data);
    return from(request).pipe(mapError());
  }

  public delete(path: string, data: object): Observable<AxiosResponse> {
    const request = this.client.delete(path, data);
    return from(request).pipe(mapError());
  }
}

export const MinosApiService = new Service();
